import React, { ChangeEventHandler } from 'react'
import { SearchIcon } from '../../assets/icons/SearchIcon'
import { NavBarInput } from '../NavBar/NavBar.styled'
import { SearchBarWrapper } from './SearchBar.styled'

export const SearchBar = ({ placeholder, onChange, width }: ISearchBar) => {
  return (
    <SearchBarWrapper style={width ? { width: '100%' } : {}} relative>
      <NavBarInput style={width ? { width: '100%' } : {}}>
        <SearchIcon />
        <input
          style={width ? { width: '100%' } : {}}
          type='text'
          onChange={onChange}
          placeholder={placeholder ? placeholder : 'Search capabilities'}
        />
      </NavBarInput>
    </SearchBarWrapper>
  )
}


interface ISearchBar {
  placeholder: string
  onChange: ChangeEventHandler<HTMLInputElement>
  width?: boolean
}
